import axios from 'axios'

export const startCallCenterActivity = () => {
  return axios.post('/api/dev/call-center-activity', { action: 'start' })
}

export const stopCallCenterActivity = () => {
  return axios.post('/api/dev/call-center-activity', { action: 'stop' })
}

export const healthcheck = () => {
  return axios.get('/api/healthcheck').then((res) => res.data)
}

export const resetCallsAndLeads = () => {
  return axios.post('/api/dev/utilitary/reset-calls-and-leads').then((res) => res.data)
}

export const generateCallsAndLeads = ({ leadsNumber }) => {
  return axios.post('/api/dev/utilitary/generate-users-and-calls', { leadsNumber }).then((res) => res.data)
}

export const connectAs = ({ role, userEmail }) => {
  return axios.post('/api/dev/connect-as', { role, userEmail }).then((res) => res.data)
}
